<template>
    <div>
        <!-- Preloader -->
        <PagePreloader v-if="!pageIsLoaded"></PagePreloader>

        <!-- Preloader -->
        <PagePreloader v-if="supportIsLoading"></PagePreloader>

        <!-- Error management -->
        <CustomAlerts :errors="errors"></CustomAlerts>

        <!-- NOTE - Announcements -->
        <CustomAnnouncements></CustomAnnouncements>

        <!-- Card -->
        <div class="card card-custom gutter-b">
            <div class="card-header">
                <div class="card-title">
                    <span class="card-icon">
                        <i class="fas fa-question-circle text-primary"></i>
                    </span>
                    <h3 class="card-label">Contact Support</h3>
                </div>
            </div>
            <div class="card-body">
                <div class="alert alert-custom alert-white shadow-sm fade show mb-5" role="alert">
                    <div class="alert-icon">
                        <i class="flaticon-questions-circular-button text-success"></i>
                    </div>
                    <div class="alert-text">
                        Have you checked the
                        <router-link to="/faq" class="font-weight-bolder text-primary"
                            >Frequently Asked Questions</router-link
                        >
                        section for an answer to most common questions?
                    </div>
                    <div class="alert-close">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true"><i class="ki ki-close"></i></span>
                        </button>
                    </div>
                </div>

                <form method="POST" v-on:submit.prevent="submitSupport">
                    <!-- Number of likes -->
                    <b-form-group label-cols="4" label-cols-lg="2" label="Email address">
                        <b-form-input
                            type="email"
                            placeholder="Enter your email here"
                            class="w-100"
                            v-model="form.email"
                        ></b-form-input>
                    </b-form-group>

                    <!-- Body input -->
                    <b-form-group label-cols="4" label-cols-lg="2" label="Message">
                        <b-form-textarea
                            name="body"
                            placeholder="Missing hashtags? Feel like a feature is missing? Explain your issue here in as much detail as possible."
                            rows="4"
                            max-rows="6"
                            v-model="form.body"
                        ></b-form-textarea>
                    </b-form-group>

                    <!-- Submit -->
                    <input
                        type="Submit"
                        @click="submitSupport"
                        class="d-none"
                        :disabled="supportIsLoading"
                    />
                </form>
            </div>
            <div class="card-footer">
                <b-button
                    variant="success"
                    @click="submitSupport"
                    :disabled="supportIsLoading"
                    class="offset-xl-2"
                >
                    Submit Support Request
                </b-button>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>

<script>
// Defaults
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
// Components
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
import CustomAnnouncements from "@/view/content/Custom/CustomAnnouncements.vue";
// Mixins
import axiosErrorManagement from "@/mixins/axiosErrorManagement";

export default {
    name: "SupportPage",
    mixins: [axiosErrorManagement],
    components: {
        PagePreloader,
        CustomAlerts,
        CustomAnnouncements,
    },
    data() {
        return {
            // Preloaders
            pageIsLoaded: false,
            supportIsLoading: false,

            // Displayers

            // Error management
            errors: [],

            // Form
            form: {
                body: "",
                email: "",
            },
        };
    },

    methods: {
        // First method here
        submitSupport() {
            // Reset errors
            this.errors = [];

            // Set preloader
            this.supportIsLoading = true;

            // Submit query
            axios
                .post("support", {
                    email: this.form.email,
                    body: this.form.body,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Check status
                    if (data.status == "OK") {
                        // Reset the form
                        this.form.email = "";
                        this.form.body = "";
                    }

                    // Handle errors
                    if (data.messages.length > 0) {
                        data.messages.forEach((item) => {
                            this.errors.push({
                                type: item.type,
                                message: item.message,
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Unset preloader
                    this.supportIsLoading = false;
                });
        },
    },

    computed: {
        currentUser() {
            return this.$store.getters["auth/currentUser"];
        },
    },

    mounted() {
        // Set page preloader
        this.pageIsLoaded = true;
        // Set default email
        this.form.email = this.currentUser.email;
        // Set breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [{ title: "Support Center", route: "support" }]);
    },
};
</script>
